import { HomeContext } from '../context'
import useHome from '../hooks/useHome'

const HomeProvider = ({ children }) => {
  const value = useHome()

  if (!value.isReady) return null

  return <HomeContext.Provider value={value}>{children}</HomeContext.Provider>
}

export default HomeProvider
